import constants from 'constants/index'

const statusName = (status) => {
  switch (status) {
    case constants.partnerService.ACTIVE_STATUS:
      return 'ATIVO'
    case constants.partnerService.INACTIVE_STATUS:
      return 'INATIVO'
    case constants.partnerService.WAITING_APPROVAL_STATUS:
      return 'AGUARDANDO APROVAÇÃO'
    case constants.partnerService.REPROVED_STATUS:
      return 'REPROVADO'
    case constants.partnerService.DISABLED_STATUS:
      return 'DESATIVADO'
    default:
      return '-'
  }
}

export default statusName
